import { TableProps } from 'antd';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Tenant } from '../../../shared/models/tenant';
import { getLanguageFromI18nLanguage } from '../../../shared/utils/language';
import { translationNamespace } from '../../constants/translation-resources';
import { getColumns } from './columns';
import { CustomTable } from '../../../shared/components/table';
import { permissionSelector } from '../../../shared/data/store/selectors/auth-selectors';

type Props = Omit<TableProps<Tenant>, 'columns' | 'rowKey'> & {
  customActions?: (tenant: Tenant) => React.ReactElement;
  sortingEnabled?: boolean;
};

export const TenantsTable: FC<Props> = ({ customActions, sortingEnabled = true, ...props }) => {
  const { t, i18n } = useTranslation(translationNamespace);
  const permissions = useSelector(permissionSelector);

  const columns = useMemo(
    () => getColumns(t, getLanguageFromI18nLanguage(i18n.language), permissions, customActions, sortingEnabled),
    [i18n.language, t, customActions, sortingEnabled, permissions]
  );

  return <CustomTable<Tenant> columns={columns} rowKey={tenant => tenant.id} {...props} />;
};
